import * as Styled from './WidgetContainer.styles';
import { PropsWithChildren } from 'react';
import InfoTooltip from '../InfoTooltip/InfoTooltip';
import ErrorTooltip from '../ErrorTooltip/ErrorTooltip';
import { Skeleton } from '@mui/material';
import { IWidgetContainer } from './WidgetContainer.types';

const WidgetContainer = ({
  title,
  infoMessage,
  skeleton,
  minHeight,
  minWidth,
  maxWidth,
  maxHeight,
  children,
  aspectRatio,
  mobileAspectRatio,
  isLoading,
  error,
  icon,
}: PropsWithChildren<IWidgetContainer>) => {
  if (skeleton) {
    return (
      <Styled.WidgetContainer elevation={0}>
        <Styled.WidgetColumnContainer>
          {/* {icon && <Styled.WidgetIconContainer>{icon}</Styled.WidgetIconContainer>} */}
          <Styled.WidgetColumn>
            <Styled.WidgetTitleContainer>
              <Skeleton>
                <Styled.WidgetTitle variant='h6'>{title}</Styled.WidgetTitle>
              </Skeleton>
              {error === true && <ErrorTooltip message={'There´s been an error while fetching data'} />}
            </Styled.WidgetTitleContainer>
            {children}
          </Styled.WidgetColumn>
        </Styled.WidgetColumnContainer>
      </Styled.WidgetContainer>
    );
  }
  return (
    <Styled.WidgetContainer
      color='primary'
      elevation={0}
      $minwidth={minWidth}
      $minheight={minHeight}
      $maxheight={maxHeight}
      $maxwidth={maxWidth}
      $ratio={aspectRatio}
      $mobileRatio={mobileAspectRatio}
    >
      {isLoading && <Styled.WidgetLoadingBar />}
      <Styled.WidgetColumnContainer>
        {icon && <Styled.WidgetIconContainer>{icon}</Styled.WidgetIconContainer>}
        <Styled.WidgetColumn>
          {(error || title) && (
            <Styled.WidgetTitleContainer>
              <Styled.WidgetTitle variant='h6'>{title}</Styled.WidgetTitle>
              {infoMessage && !error && <InfoTooltip message={infoMessage || ''} />}
              {error && <ErrorTooltip message={'There´s been an error while fetching data'} />}
            </Styled.WidgetTitleContainer>
          )}
          {children}
        </Styled.WidgetColumn>
      </Styled.WidgetColumnContainer>
    </Styled.WidgetContainer>
  );
};
export default WidgetContainer;
